import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';
import { RootState } from '..';

const initialState: IReduxState<IImageSlice> = {
    status: EReduxState.initialState,
};

export interface IResultCalculationImage {
    axis?: string;
    preFsStatic?: string;
    postFsStatic?: string;
    preFsSeismic?: string;
    postFsSeismic?: string;
}

export interface IImageSlice {
    map: string;
    preliminaryCalculation: string;
    generalView: string;
    transversalSectionPrimaryDrainageTrench: string;
    transversalSectionSecondaryDrainageTrench: string;
    longitudinalStaticSection: string;
    longitudinalSeismicSection: string;
    resultCalculation: IResultCalculationImage;
}

export const imageSlice = createSlice({
    name: 'image',
    initialState,
    reducers: {
        cleanImage: state => {
            state.status = EReduxState.initialState;
        },
        setMapImage: (state, action: PayloadAction<string>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, map: action.payload };
        },
        setPreliminaryCalculationImage: (state, action: PayloadAction<string>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, preliminaryCalculation: action.payload };
        },
        setGeneralViewImage: (state, action: PayloadAction<string>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, generalView: action.payload };
        },
        setTransversalSectionPrimaryDrainageTrenchImage: (state, action: PayloadAction<string>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, transversalSectionPrimaryDrainageTrench: action.payload };
        },
        setTransversalSectionSecondaryDrainageTrenchImage: (state, action: PayloadAction<string>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, transversalSectionSecondaryDrainageTrench: action.payload };
        },
        setLongitudinalStaticSectionImage: (state, action: PayloadAction<string>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, longitudinalStaticSection: action.payload };
        },
        setLongitudinalSeismicSectionImage: (state, action: PayloadAction<string>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, longitudinalSeismicSection: action.payload };
        },
        setResultCalculationImage: (state, action: PayloadAction<IResultCalculationImage>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, resultCalculation: { ...state.data?.resultCalculation, ...action.payload } };
        },
    },
});

export const {
    cleanImage,
    setMapImage,
    setLongitudinalStaticSectionImage,
    setLongitudinalSeismicSectionImage,
    setPreliminaryCalculationImage,
    setResultCalculationImage,
    setGeneralViewImage,
    setTransversalSectionPrimaryDrainageTrenchImage,
    setTransversalSectionSecondaryDrainageTrenchImage,
} = imageSlice.actions;

export const selectImage = (state: RootState) => state.image;

export default imageSlice.reducer;
